import { createStore } from 'vuex'
import getters from '@/store/getters'
import user from '@/store/modules/user'

export default createStore<{ [key: string]: any }>({
  state: {},
  mutations: {},
  actions: {},
  getters,
  modules: {
    user
  }
})
